import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, Validators} from '@angular/forms';

export interface SnmpDestinationDialog {
  selectedItem: any;
  isEditMode?: boolean;
}

@Component({
  selector: 'snmp-destination-dialog',
  templateUrl: './snmp-destination-dialog.component.html',
  styleUrls: ['./snmp-destination-dialog.component.scss']
})
export class SnmpDestinationDialogComponent implements OnInit {

  onApply = new EventEmitter();
  onCancel = new EventEmitter();
  portControl: FormControl;

  constructor(public dialogRef: MatDialogRef<SnmpDestinationDialog>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {

    if (!this.data.isEditMode){
      this.data.selectedItem = {};
    }

    this.portControl = new FormControl('', [Validators.required, Validators.max(65535), Validators.min(1)]);
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    this.preSubmitOperations();
    this.onApply.emit(this.data.selectedItem);
  }

  preSubmitOperations(): void {
    if (!this.data.selectedItem.isAIM) {
      this.data.selectedItem.deviceDescription = null;
    }
  }
}
